import type { ServerEnvConfigType } from '@/shared/config/ServerEnvConfigType';
import type { DocsSiteVisitType } from '@/shared/constant/DocsIdTypeData';
import type { LocaleType } from '@/shared/i18n/i18n';
import { clientRequest } from '@/shared/request/clientRequest.client';

export type RequestVerifyEmailCodeDataType = {
  id: number | string;
  email: string;
  projectId: number;
  code: string;
};

export async function requestVerifyEmailCode(
  requestData: RequestVerifyEmailCodeDataType,
  envConfig: ServerEnvConfigType,
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string,
  visitType?: DocsSiteVisitType,
  subdirectory?: string,
) {
  const url = `/api/v1/projects/${requestData.projectId}/docs-sites/${requestData.id}/email-verification-code`;

  return await clientRequest(
    url,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: new URLSearchParams({
        id: requestData.id.toString(),
        email: requestData.email,
        code: requestData.code,
      }),
      envConfig,
      projectId: Number(requestData.projectId || 0),
      visitType,
      subdirectory,
    },
    clientI18n,
  );
}
